import { gql } from 'graphql-request'

export const UPDATE_STICKER = gql`
  mutation UpdateSticker($updateStickerInput: UpdateStickerInput!) {
    updateSticker(updateStickerInput: $updateStickerInput) {
      id
    }
  }
`
